<template>
	<b-modal
		v-model="showDialog"
		header-class="header-class-modal-doc-package"
		header-bg-variant="light"
		:title="dialogTitle"
		no-close-on-backdrop
		no-close-on-esc
		hide-header-close
		scrollable
		:centered="centered"
		:size="size"
		:modal-class="{ 'mobile-full-screen': $screen.width < 600 }"
	>
		<template #modal-header>
			<div class="d-flex align-items-center w-100">
				<div class="w-50">
					<h5 class="modal-title">{{ dialogTitle }}</h5>
				</div>
				<div class="d-flex flex-row justify-content-end align-items-center w-50 gap-5">
					<button
						type="button"
						class="btn-close-custom-modal"
						:class="!disableCanelOrClose ? 'cursor-pointer-apsect' : ''"
						@click="closeProcess"
						:disabled="disableCanelOrClose"
					>
						×
					</button>
				</div>
			</div>
		</template>
		<slot name="content"></slot>
		<template #modal-footer>
			<div class="w-100">
				<b-row :class="maxMobileScreenWidth ? 'p-0' : 'padding-c-1'">
					<b-col sm="12" md="7" class="h-inherit" :class="{ 'mobile-error-font mb-2': maxMobileScreenWidth }" v-if="showError">
						<div class="p-1 border rounded warning-invoice d-flex align-items-center" style="gap: 7px">
							<component :is="getLucideIcon('AlertCircle')" :size="maxMobileScreenWidth ? 16 : 24" :stroke-width="1.5" />
							<slot name="error-message"></slot>
						</div>
					</b-col>
					<b-col sm="12" :md="showError ? '5' : '12'" class="h-inherit">
						<div class="d-flex flex-row align-items-center w-100" :class="maxMobileScreenWidth ? 'justify-content-center' : 'justify-content-end'">
							<b-button size="md" variant="custom-outline-gray" class="w-138-px mr-3" @click="closeProcess" :disabled="disableCanelOrClose">
								{{ btnCloseLabel }}
							</b-button>
							<b-button
								v-if="showSaveButton"
								:disabled="!enableNextOrSave"
								size="md"
								variant="primary"
								class="w-138-px mr-3"
								@click="nextOrSaveProcess"
							>
								<div style="margin-top: 1px">{{ btnSaveLabel }}</div>
							</b-button>
							<slot name="additional-buttons-right"></slot>
						</div>
					</b-col>
				</b-row>
			</div>
		</template>
	</b-modal>
</template>

<script>
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';
import invoicesToolsMixin from '@/mixins/invoicesTools.mixin';

// props
import mapProps from '@/shared/vuePropsMapper';

export default {
	name: 'DialogContainer',
	mixins: [languageMessages, globalMixin, invoicesToolsMixin],
	props: {
		...mapProps(['dialogTitle', 'btnCloseLabel', 'btnSaveLabel'], {
			type: String,
			required: true,
			default: ''
		}),
		show: {
			type: Boolean,
			required: true,
			default: false
		},
		showError: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'lg'
		},
		centered: {
			type: Boolean,
			default: true
		},
		disableCanelOrClose: {
			type: Boolean,
			default: false
		},
		enableNextOrSave: {
			type: Boolean,
			default: false
		},
		showSaveButton: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			showDialog: false
		};
	},
	methods: {
		closeProcess() {
			this.$emit('close');
		},
		nextOrSaveProcess() {
			this.$emit('nextOrSave');
		}
	},
	watch: {
		show: {
			handler(newVal) {
				this.showDialog = newVal;
			},
			immediate: true
		}
	}
};
</script>

<style scoped>
.cursor-pointer-apsect {
	cursor: pointer;
}
.h-inherit {
	height: inherit;
}
.btn-close-custom-modal {
	display: flex;
	font-size: 2.5rem;
	line-height: 1;
	color: #000;
	text-shadow: 0 1px 0 #fff;
	opacity: 0.5;
	border: none;
	border-color: none;
	appearance: none;
	background-color: transparent;
	border: 0;
}
.warning-invoice {
	color: #bc9581;
	border-color: #bc9581;
}
:deep(.mobile-full-screen .modal-dialog .modal-content) {
	width: 100% !important;
	height: 95vh !important;
	max-height: 100% !important;
	position: fixed !important;
	padding-top: 15px !important;
	padding-bottom: 50px !important;
	right: 0 !important;
	bottom: 0 !important;
	left: 0 !important;
}
:deep(.mobile-error-font) {
	font-size: 0.8em !important;
}
</style>
